import axios from "axios";
import jwt_decode from "jwt-decode";
import { store } from "../redux/store";
import { setLogout } from "../redux/redux/global/action";

// function for api call using axios according to env

const mode = (type) => {
  switch (type) {
    case "development":
      return process.env.REACT_APP_AEM_TRANS_API_URL; // development URL
      

    case "production":
    return process.env.REACT_APP_AEM_TRANS_API_URL; // production URL

    default:
      //return development api

      return process.env.REACT_APP_AEM_TRANS_API_URL;

  }
};
const defaultOptions = {
  // baseURL: base.url,
  baseURL: mode(process.env.REACT_APP_CUSTOM_ENV),
  method: "get",
  headers: {
    "Content-Type": "application/json",
    // "Access-Control-Allow-Origin": "*",
  },
};

// Create instance
let instance = axios.create(defaultOptions);
instance.interceptors.request.use(
  function (config) {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// instance.interceptors.response.use(
//   (response) => {
//     return Promise.resolve(response);
//   },
//   (error) => {
//     if (error.message === "Network Error" && !error.response) {
//     }
//     if (
//       401 === error?.response?.status
//     ) {
//       store.dispatch(setLogout());
//       return error;
//     }

//     if (error) {
//       return Promise.reject(error);
//     }
//   }
// );

export const getToken = () => {
  // function to verify JWT token
  const { token } = store.getState().global;
  if (token) {
    try {
      const JWT = jwt_decode(token);
      const currentDate = Math.round(new Date().getTime() / 1000);
      if (JWT && JWT.exp > currentDate) {
        return token;
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  return null;
};

export const checkToken = (token) => {
  try {
    const JWT = jwt_decode(token);
    const currentDate = Math.round(new Date().getTime() / 1000);
    if (JWT && JWT.exp > currentDate) {
      return JWT;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export default instance;
